"use strict";

module.exports = require('./ui-login-widget').default;
require('/var/lib/jenkins/workspace/pf-yts-ui_Release_0/node_modules/ui-login-widget/dist/ui-login-widget.scss');